// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"38":"3644a18a","190":"1df37385","395":"b6d4d83e"}[chunkId] + ".js";
};